var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rfq',[_c('div',{staticClass:"cust-travel-wrap guest-quote-page"},[_c('travel-plan-select-page',{attrs:{"channel":"customer","guest":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }